import React, {useEffect} from 'react';
import {FormattedMessage, injectIntl} from "react-intl";

import {connect} from "react-redux";
import {getFabricatorSubscriptions} from "../NewScope/newScopeActions";
import {setWizardVisualizer} from "./wizardActions";
import BlueDropDown from "../PageLayout/DropDowns/BlueDropDown";

export const getAvailableWizardVisualizerOptions = (subscriptions, intl, subscriptionsOnly = false) => {
  let options = subscriptions.map(sub => {
    return {
      text: intl.formatMessage({id: "wizard.subscription." + sub.service}),
      value: sub.service,
    }
  });
  if (subscriptionsOnly) {
    return options
  }
  return [...options, {text: "All", value: "all"}]
}


const WizardSetupTopVisualizerSelect = (props) => {

  const {fabricatorSubscriptions, fabricatorSubscriptionsReceived, wizardVisualizer, setWizardVisualizer, intl} = props;

  console.log("fabricatorSubscriptions", fabricatorSubscriptions);

  if (!fabricatorSubscriptionsReceived) {
    return (
      <div className="wizard-top__select text-center">
        <div className="ui-loader ui-loader--small"/>
      </div>
    )
  }

  if (!fabricatorSubscriptions.length) {
    return null
  }

  useEffect(() => {
    if (fabricatorSubscriptionsReceived && fabricatorSubscriptions.length && !wizardVisualizer) {
      setWizardVisualizer(fabricatorSubscriptions[0].service);
    }
  }, [fabricatorSubscriptionsReceived, fabricatorSubscriptions])

  const onSelect = (item) => {
    setWizardVisualizer(item.value);
  }

  const dropDownItems = getAvailableWizardVisualizerOptions(fabricatorSubscriptions, intl)

  return (
    <div className="wizard-top__select">
      <BlueDropDown items={dropDownItems}
                    onItemClick={onSelect}
                    selectedItem={dropDownItems.find(sub => sub.value === wizardVisualizer)}
                    itemKey={(item) => item.text}
                    itemValue={(item) => item.text}/>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {fabricatorSubscriptions, fabricatorSubscriptionsReceived} = store.newScope;
  const {wizardVisualizer} = store.wizardState;
  return {
    fabricatorSubscriptions,
    fabricatorSubscriptionsReceived,
    wizardVisualizer,
  };
};

const mapDispatchToProps = {
  getFabricatorSubscriptions,
  setWizardVisualizer,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(WizardSetupTopVisualizerSelect)
)
